import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField
} from "@material-ui/core";
import i18n from "i18next";
import React, { useState } from "react";
import { validateEmail } from "../../../../helpers/utilities";

/**
 * Dialog used by the auto forward message action when the action config has no "to":
 * the agent must fill a valid email address to forward the message to
 */
const AutoForwardEmailDialog = ({ open, handleClose, handleValidate }) => {
	const [email, setEmail] = useState("");
	const [showError, setShowError] = useState(false);

	const trimmedEmail = email.trim();
	const isValid = validateEmail(trimmedEmail);

	/**
	 * Close dialog and reset the field
	 */
	function closeDialog() {
		setEmail("");
		setShowError(false);
		handleClose();
	}

	/**
	 * Send the email only if it is valid, otherwise display the error
	 */
	function closeAndValidate() {
		if (!isValid) {
			setShowError(true);
			return;
		}
		handleValidate(trimmedEmail);
		setEmail("");
		setShowError(false);
	}

	return (
		<Dialog open={open} onClose={closeDialog} fullWidth maxWidth="sm">
			<DialogTitle>{i18n.t("COC.autoForwardTitle")}</DialogTitle>
			<DialogContent>
				<DialogContentText>{i18n.t("COC.autoForwardMessage")}</DialogContentText>
				<TextField
					autoFocus
					fullWidth
					type="email"
					variant="outlined"
					size="small"
					label={i18n.t("COC.autoForwardEmailLabel")}
					value={email}
					onChange={e => {
						setEmail(e.target.value);
						if (showError) setShowError(false);
					}}
					onKeyDown={e => {
						if (e.key === "Enter") closeAndValidate();
					}}
					error={showError}
					helperText={showError ? i18n.t("COC.autoForwardEmailInvalid") : ""}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={closeDialog} color="primary">
					{i18n.t("COC.disagree")}
				</Button>
				<Button onClick={closeAndValidate} color="primary" disabled={!trimmedEmail}>
					{i18n.t("COC.autoForwardValidate")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AutoForwardEmailDialog;
